import mnaraDesktop from "../../../assets/images/about/mnara.svg";
import mnaraMobile from "../../../assets/images/about/mnara.png";
import hero from "../../../assets/images/about/hero.png";

const Hero = ({ isMobile, aboutHero }) => (
  <div
    className="h-screen md:h-120 lg:h-screen flex items-center bg-cover bg-center bg-no-repeat"
    style={{ backgroundImage: `url(${isMobile ? mnaraMobile : mnaraDesktop})` }}
  >
    <div className="flex flex-col justify-center items-center w-4/5 md:w-1/2 mx-auto relative">
      <img
        className="w-4/5 relative top-10 md:top-20 lg:top-24 xl:top-32"
        src={hero}
        alt="Hero"
      />

      <div className="bg-blue-900 opacity-95 shadow-xl relative z-10 text-white p-3 lg:p-4 xl:p-6">
        <h4 className="text-3xl lg:text-4xl xl:text-5xl mb-2">Who are we?</h4>
        <p className="text-xs lg:text-sm xl:text-base">
          {aboutHero?.whoWeAreDescription}

        </p>
      </div>
    </div>
  </div>
);

export default Hero;
